import { cashdeskPageDevicesModel } from 'pages/cashdesk-page/model';
import { createDeleteDeviceDetailedModal } from 'features/delete-device';
import { createEditDeviceDetailedModal } from 'features/edit-device';
import { createDeviceRegistry } from 'entities/device';
import cls from './cashdesk-page-devices.module.scss';

const DevicesRegistry = createDeviceRegistry(cashdeskPageDevicesModel.deviceRegistryModel);

const DeleteDeviceModal = createDeleteDeviceDetailedModal(
	cashdeskPageDevicesModel.deleteDeviceModel,
);

const EditDeviceModal = createEditDeviceDetailedModal(cashdeskPageDevicesModel.editDeviceModel);

export const CashdeskPageDevices = () => (
	<>
		<DevicesRegistry
			withAccount={false}
			withCashdesk={false}
			withCashdeskFilter={false}
			withTitle={false}
			className={cls.cashdeskPageDevicesRegistry}
			tableTdActionSlot={(device) => (
				<div className={cls.cashdeskPageDevicesActions}>
					<EditDeviceModal.ActionIcon modalData={device} />
					<DeleteDeviceModal.ActionIcon modalData={device} />
				</div>
			)}
		/>
		<DeleteDeviceModal />
		<EditDeviceModal />
	</>
);
